export { default as store } from './store/index'
export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/patient/agendas/index.js